export default "__VITE_PUBLIC_ASSET__67c28499__"